// extracted by mini-css-extract-plugin
export default {"cards":"cards___CDkLE","card":"card___WqNFi","card_btn":"card_btn___FKTFG"};